import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();

  // KULLANICI ROLLERİNİ BELİRLEME — HESAP_TURU alanına göre (varchar)
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const hesapTuru = authUser?.HESAP_TURU || "";

  const isAlici = hesapTuru === "Alıcı";
  const isSatici = hesapTuru === "Satıcı";
  const isAdmin = hesapTuru === "Admin";

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">

            {/* ==================== GENEL ==================== */}
            <li className="menu-title">{props.t("Menü")}</li>

            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Anasayfa")}</span>
              </Link>
            </li>

            {/* ==================== HESAP ==================== */}
            <li className="menu-title">{props.t("Hesap")}</li>

            {/* Sertifikalarım - sadece Satıcı ve Admin görür */}
            {(isSatici || isAdmin) && (
              <li>
                <Link to="/sertifikalarim">
                  <i className="bx bx-check-shield"></i>
                  <span>{props.t("Sertifikalarım")}</span>
                </Link>
              </li>
            )}

            <li>
              <Link to="/hesabim">
                <i className="bx bx-user"></i>
                <span>{props.t("Hesabım")}</span>
              </Link>
            </li>

            {/* ==================== İLANLAR ==================== */}
            
            {/*    <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store-alt"></i>
                <span>{props.t("İlanlar")}</span>
              </Link>
              <ul className="sub-menu">
                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/job-list">{props.t("İlan Listesi")}</Link>
                  </li>
                )}

                <li>
                  <Link to="/job-apply">
                    {isAlici ? props.t("Taleplerim") : props.t("Siparişler")}
                  </Link>
                </li>
              </ul>
            </li> */}
        

            {/* ==================== PROFİLİM ==================== */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-id-card"></i>
                <span>{props.t("Profilim")}</span>
              </Link>
              <ul className="sub-menu">

                <li>
                  <Link to="/ecommerce-orders">{props.t("Faturalarım")}</Link>
                </li>

                <li>
                  <Link to="/tasks-list">{props.t("Değerlendirmelerim")}</Link>
                </li>

                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/ecommerce-products">{props.t("Tekliflerim")}</Link>
                  </li>
                )}

                <li>
                  <Link to="/ecommerce-customers">{props.t("Faturalandırma Bilgileri")}</Link>
                </li>

                {/* Alıcı ve Admin mağaza başvurusu yapabilir, zaten satıcı olanlar için gerek yok */}
              {/**   {(isAlici || isAdmin) && (
                  <li>
                    <Link to="/candidate-list">{props.t("Mağaza Başvurusu")}</Link>
                  </li>
                )}

                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/ecommerce-add-product">{props.t("Yeni İlan Ver")}</Link>
                  </li>
                )}
*/}
              
              
              </ul>
            </li>

            {/* ==================== YÖNETİM (SADECE ADMİN) ==================== */}
            {isAdmin && (
              <>
                <li className="menu-title">{props.t("Yönetim")}</li>

                {/* İçerik Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-edit-alt"></i>
                    <span>{props.t("İçerik Yönetimi")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/blog-list">{props.t("Blog Yazıları")}</Link>
                    </li>
                    <li>
                      <Link to="/slider-yonetimi">{props.t("Slider Görselleri")}</Link>
                    </li>
                    <li>
                      <Link to="/iletisim-mesajlari">{props.t("İletişim Mesajları")}</Link>
                    </li>
                    <li>
                      <Link to="/email-inbox">{props.t("Bildirim Yönetimi")}</Link>
                    </li>
                  </ul>
                </li>

                {/* İlan & Ürün Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-package"></i>
                    <span>{props.t("İlan Yönetimi")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/ilan-yonetimi">{props.t("Tüm İlanlar")}</Link>
                    </li>
                    <li>
                      <Link to="/kategori-yonetimi">{props.t("Kategoriler")}</Link>
                    </li>
                    <li>
                      <Link to="/magaza-yonetimi">{props.t("Mağazalar")}</Link>
                    </li>
                    <li>
                      <Link to="/sertifika-tanimlari">{props.t("Sertifika Tanımları")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Sipariş & Teslimat */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-cart"></i>
                    <span>{props.t("Sipariş Yönetimi")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/siparis-yonetimi">{props.t("Tüm Siparişler")}</Link>
                    </li>
                    <li>
                      <Link to="/teslimat-yonetimi">{props.t("Teslimatlar")}</Link>
                    </li>
                    <li>
                      <Link to="/iade-talepleri">{props.t("İade Talepleri")}</Link>
                    </li>
                    <li>
                      <Link to="/mezat-yonetimi">{props.t("Mezatlar")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Finans */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-credit-card"></i>
                    <span>{props.t("Finans")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/crypto-wallet">{props.t("Sistem Finans")}</Link>
                    </li>
                    <li>
                      <Link to="/para-cekme-talepleri">{props.t("Para Çekme Talepleri")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Kullanıcı Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-user-detail"></i>
                    <span>{props.t("Kullanıcılar")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/contacts-list">{props.t("Kullanıcı Listesi")}</Link>
                    </li>
                    {/**  <li>
                      <Link to="/contacts-profile">{props.t("Firma Bilgileri")}</Link>
                    </li> */}
                  
                  </ul>
                </li>

                {/* Sistem */}
                <li>
                  <Link to="/apps-filemanager">
                    <i className="bx bx-file"></i>
                    <span>{props.t("Dosya Yöneticisi")}</span>
                  </Link>
                </li>

              </>
            )}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
